import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/tou_xiang.png'


const _withScopeId = n => (_pushScopeId("data-v-738f90ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logout" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "img",
  fit: "cover",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("立即注销")

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { removeAccountApi } from "@/api/login"
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'logout',
  setup(__props) {

const route = useRoute()
const url = ref()
onMounted(() => {
  if (localStorage.getItem("touxiang")) {
    const id = localStorage.getItem("touxiang").split("?sfid=")[1]
    if (id) {
      url.value = DataList.UpdtImagePrefix() + id
    }
  }
  // url.value = localStorage.getItem("touxiang") || ""
})
// 注销账号
const remove = () => {
  showConfirmDialog({
    message: "确认注销该账号！"
  })
    .then(() => {
      showLoadingToast({
        message: "注销中"
      })
      var sfid = route.query?.sfid
      removeAccountApi(sfid).then((res: any) => {
        closeToast()
        if (res.code == 200) {
          closeToast()
          showNotify({ type: "success", message: "注销成功" })
          // 清除所有缓存
          localStorage.clear()
          // 跳转到首页
          router.push({ path: "/home" })
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    })
    .catch(() => {
      // 取消
    })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (url.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "img",
          fit: "cover",
          src: url.value,
          alt: ""
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createVNode(_component_van_button, {
      color: "#ff5a5a",
      type: "primary",
      class: "yellow_button",
      onClick: remove
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}
}

})